import React, { useMemo, useRef, useState } from "react";
import { globalDropdownsZIndex } from "@smartsuite/react-ui/lib/constants/zIndex";
import { EditorToolbar } from "../../../../react/EditorToolbar/EditorToolbar";
import { EditorToolbarButton } from "../../../../react/EditorToolbarButton/EditorToolbarButton";
import { EditorToolbarDropdownButton } from "../../../../react/EditorToolbarDropdownButton/EditorToolbarDropdownButton";
import { text } from "../../text";
import { Icon } from "@smartsuite/react-ui/lib/components/utils/Icon/Icon";
import { DropdownPanel } from "@smartsuite/react-ui/lib/components/dropdowns/DropdownPanel/DropdownPanel";
export const TextAlignDropdownButton = ({ state, commands, disableTooltips = false, showArrow = true, onCommand, }) => {
    var _a, _b;
    const [isOpened, setIsOpened] = useState(false);
    const buttonRef = useRef();
    const handleCommand = (command) => () => {
        onCommand(command);
        setIsOpened(false);
    };
    const items = useMemo(() => {
        return {
            alignLeft: {
                title: text.alignLeft,
                command: commands.applyTextAlignment("left"),
                icon: "formatting-align-left",
            },
            alignCenter: {
                title: text.alignCenter,
                command: commands.applyTextAlignment("center"),
                icon: "formatting-align-center",
            },
            alignRight: {
                title: text.alignRight,
                command: commands.applyTextAlignment("right"),
                icon: "formatting-align-right",
            },
        };
    }, [commands]);
    const activeItem = (_b = (_a = Object.entries(items).find(([, value]) => value.command.active(state))) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : items.alignLeft;
    return (React.createElement(React.Fragment, null,
        React.createElement(EditorToolbarDropdownButton, { ref: buttonRef, title: text.textAlign, isOpened: isOpened, disableTooltip: disableTooltips, showArrow: showArrow, onClick: () => setIsOpened((opened) => !opened) },
            React.createElement(Icon, { name: activeItem.icon, size: "S", color: "currentColor" })),
        React.createElement(DropdownPanel, { isActive: isOpened, targetElementRef: buttonRef, zIndex: globalDropdownsZIndex, onClickOutside: () => setIsOpened(false), my: "center top", at: "center bottom" },
            React.createElement(EditorToolbar, null, Object.entries(items).map(([key, item]) => (React.createElement(EditorToolbarButton, { key: key, title: item.title, icon: item.icon, iconSize: "S", disabled: !item.command.enable(state), active: item.command.active(state), onClick: handleCommand(item.command) })))))));
};
